export default __webpack_public_path__ + "static/media/csharp.a7ec03d2.svg";